import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import Immutable from "immutable";
import formValueSelector from "redux-form/lib/formValueSelector";
import actions from "redux-form/lib/actions";
// import debounce from 'lodash/debounce';
import isEqual from "lodash/isEqual";
import $ from "jquery";

import SchemaField from "../../component/SchemaField";
import { hydratePostcode as hydratePostcodeData } from "../../store/modules/cart";
import { isValidZipCodeNL } from "../../lib/formUtils";
import { hasBodyClass } from "../../lib/utils";

import "./Address.scss";

/**
 * Address
 */
class Address extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    hasZipcodeAndStreetNumber: PropTypes.bool.isRequired,
    hasStreetOrCity: PropTypes.bool.isRequired,
    isNL: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    zipcode: PropTypes.string,
    streetNumber: PropTypes.string,
    autoCompletePrefix: PropTypes.string,
    autoComplete: PropTypes.string,
    hydratePostcodeData: PropTypes.func.isRequired,
    changeField: PropTypes.func.isRequired,
    hasCountryCode: PropTypes.bool,
    helptexts: PropTypes.shape({
      countryCode: PropTypes.string,
      zipcode: PropTypes.string,
      houseNumber: PropTypes.string,
      street: PropTypes.string,
      city: PropTypes.string
    })
  };

  static defaultProps = {
    hasCountryCode: true,
    disabled: false,
    zipcode: null,
    streetNumber: null,
    name: null,
    autoCompletePrefix: "",
    autoComplete: null,
    helptexts: {}
  };

  state = {
    pcError: null
  };

  shouldComponentUpdate(nextProps, nextState) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  onFillFromPostcode = () => {
    const { name, isNL, zipcode, streetNumber, changeField } = this.props;

    if (!isNL || !zipcode || !streetNumber || !isValidZipCodeNL(zipcode)) {
      return;
    }

    this.props
      .hydratePostcodeData({
        zipcode,
        streetNumber
      })
      .then(payload => {
        if (payload.error) {
          this.setState({ pcError: true });
          return payload;
        }
        this.setState({ pcError: false });
        const namePrefix = name ? `${name}.` : "";

        changeField("cart", `${namePrefix}street`, payload.street);
        changeField("cart", `${namePrefix}city`, payload.city);
        changeField("cart", `${namePrefix}detectedType`, payload.addressType);

        if (!hasBodyClass("is-mobile")) {
          $(`input[name="${namePrefix}phone"]`).focus();
        }
        return payload;
      });
  };

  getAutoComplete(key) {
    const { autoComplete, autoCompletePrefix } = this.props;
    if (autoComplete === "off") {
      return autoComplete;
    }
    return `${autoCompletePrefix} ${key}`;
  }

  render() {
    const { name, disabled, hasZipcodeAndStreetNumber, hasStreetOrCity, isNL, schema, helptexts } = this.props;

    const namePrefix = name ? `${name}.` : "";

    return (
      <div className="Address">
        {this.props.hasCountryCode && (
          <SchemaField
            name={`${namePrefix}countryCode`}
            disabled={disabled}
            schema={schema}
            autoComplete={this.getAutoComplete("country-code")}
            tooltip={helptexts.countryCode}
          />
        )}

        <div className={this.state.pcError ? "is-postcode-error" : ""}>
          {this.state.pcError && (
            <div>
              {this.props.t("zipcodeHelp")}&nbsp;
              <a href="https://www.postcode.nl" target="_blank" rel="noopener noreferrer">
                https://www.postcode.nl
              </a>
            </div>
          )}
          <SchemaField
            onBlur={this.onFillFromPostcode}
            name={`${namePrefix}zipcode`}
            disabled={disabled}
            autoComplete={this.getAutoComplete("postal-code")}
            schema={schema}
            tooltip={helptexts.zipcode}
          />
          <SchemaField
            onBlur={this.onFillFromPostcode}
            name={`${namePrefix}streetNumber`}
            disabled={disabled}
            autoComplete={this.getAutoComplete("address-line1")}
            schema={schema}
            tooltip={helptexts.streetNumber}
          />
        </div>

        {(hasZipcodeAndStreetNumber || hasStreetOrCity || !isNL) && (
          <div>
            <SchemaField
              name={`${namePrefix}street`}
              disabled={disabled}
              autoComplete={this.getAutoComplete("address-line2")}
              schema={schema}
              tooltip={helptexts.street}
            />
            <SchemaField
              name={`${namePrefix}city`}
              disabled={disabled}
              autoComplete={this.getAutoComplete("address-level2")}
              schema={schema}
              tooltip={helptexts.city}
            />
          </div>
        )}

        <SchemaField name={`${namePrefix}detectedType`} schema={schema} type="hidden" />
      </div>
    );
  }
}

const valueSelector = formValueSelector("cart");
export default translate()(
  connect(
    (state, props) => {
      const namePrefix = props.name ? `${props.name}.` : "";
      return {
        zipcode: valueSelector(state, `${namePrefix}zipcode`),
        streetNumber: valueSelector(state, `${namePrefix}streetNumber`),
        isNL: valueSelector(state, `${namePrefix}countryCode`) === "NL",
        hasStreetOrCity: !!(valueSelector(state, `${namePrefix}street`) || valueSelector(state, `${namePrefix}city`)),
        hasZipcodeAndStreetNumber: !!(
          valueSelector(state, `${namePrefix}zipcode`) && valueSelector(state, `${namePrefix}streetNumber`)
        )
      };
    },
    {
      hydratePostcodeData,
      changeField: actions.change,
      focusField: actions.focus
    }
  )(Address)
);
